import { CircularProgress } from '@mui/material';
import { memo } from 'react';

const Loading = memo(() => {
  return (
    <CircularProgress
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginLeft: '-20px',
        marginTop: '-20px',
      }}
    />
  );
});

export default Loading;
